import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { gql, useLazyQuery } from "@apollo/client";
import SearchBar from "material-ui-search-bar";
import Highlighter from "react-highlight-words";
import {
  Modal,
  Card,
  makeStyles,
  Grid,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  ListItemIcon,
  Checkbox,
  Button,
  CardContent,
  CircularProgress,
  IconButton,
  useMediaQuery,
} from "@material-ui/core";
import { CloseRounded } from "@material-ui/icons";
import { useTheme } from "@material-ui/core/styles";
import { resumeActions } from "../../_redux/resumeActions";
// import getJobIdeas from "./searchJobIdeas";

const SEARCH_JOB_IDEAS = gql`
  query Query($searchJobIdeasSearch: String!) {
    searchJobIdeas(search: $searchJobIdeasSearch) {
      title
      jobTitleSamples
      occupationId
      workActivities {
        id
        description
      }
      detailedWorkActivities {
        name
      }
    }
  }
`;

export default () => {
  const classes = makeStyles((theme) => ({
    previewCard: {
      position: "absolute",
      width: "60%",
      height: "95%",
      backgroundColor: "whitesmoke",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      [theme.breakpoints.down("sm")]: {
        width: "95%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      [theme.breakpoints.down("xs")]: {
        width: "95%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
    },
    copyButton: {
      position: "absolute",
      right: "25px",
    },
    highlight: {
      backgroundColor: "#ffd63f",
    },
    headerContainer: {
      display: "flex",
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        marginTop: theme.spacing(2),
        gap: theme.spacing(1),
      },
    },
    searchBarClass: {
      width: "100%",
    },
    closIcon: {
      position: "absolute",
      top: "0px",
      right: "0px",
    },
    detailsAction: {
      height: "82vh",
      // [theme.breakpoints.down("xs")]: { height: "50vh" },
    },
  }))();
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = React.useState("");
  const [selectedOccupation, setSelectedOccupation] = React.useState(-1);

  const { showIdeasDialog } = useSelector((state) => ({
    showIdeasDialog: state.resume.showIdeasDialog,
  }));

  // const searchJobIdeasData = getJobIdeas();
  // const searchJobIdeasCalled = true;

  const [selectedIdeas, setSelectedIdeas] = React.useState([]);
  const [selectedIdeasId, setSelectedIdeasId] = React.useState([]);

  const selectJobIdea = (id, value) => {
    setSelectedIdeasId([...selectedIdeasId, id]);
    return setSelectedIdeas([...selectedIdeas, value]);
  };

  const deselectJobIdea = (id, value) => {
    setSelectedIdeasId(selectedIdeasId.filter((i) => i !== id));
    return setSelectedIdeas(selectedIdeas.filter((i) => i !== value));
  };

  const [
    searchJobIdeas,
    {
      called: searchJobIdeasCalled,
      loading: searchJobIdeasLoading,
      data: searchJobIdeasData,
    },
  ] = useLazyQuery(SEARCH_JOB_IDEAS);

  function handleClose() {
    setSelectedIdeas([]);
    dispatch(resumeActions.setShowIdeasDialog(false));
  }
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Modal open={showIdeasDialog} onClose={handleClose}>
        <Card className={classes.previewCard}>
          <IconButton
            className={classes.closIcon}
            size="medium"
            onClick={() => dispatch(resumeActions.setShowIdeasDialog(false))}
          >
            <CloseRounded />
          </IconButton>
          <Box className={classes.headerContainer}>
            <SearchBar
              className={classes.searchBarClass}
              value={searchValue}
              onChange={setSearchValue}
              onRequestSearch={() =>
                searchJobIdeas({
                  variables: { searchJobIdeasSearch: searchValue },
                })
              }
            />

            <Box display="flex">
              <Button
                className="mr-5 mt-2 text-white"
                variant="contained"
                color="primary"
                size="large"
                onClick={() =>
                  searchJobIdeas({
                    variables: { searchJobIdeasSearch: searchValue },
                  })
                }
              >
                Search
              </Button>
              <Button
                className="mr-5 mt-2"
                variant="contained"
                color="primary"
                disabled={selectedIdeas.length === 0}
                size="large"
                onClick={() => {
                  dispatch(
                    resumeActions.setCopiedIdeas(selectedIdeas.join("\n\n"))
                  );
                  handleClose();
                }}
              >
                Copy
              </Button>
            </Box>
          </Box>

          <CardContent>
            <Grid
              container
              spacing={4}
              justify="space-around"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={2}
                  justify="center"
                  alignItems="center"
                >
                  {!searchJobIdeasCalled ? (
                    <Grid item xs={12} className="text-center">
                      Search Occupation
                    </Grid>
                  ) : searchJobIdeasLoading ? (
                    <Grid item xs={12} className="text-center">
                      <CircularProgress style={{ color: "#3699FF" }} />
                    </Grid>
                  ) : (
                    <>
                      {/* LEFT SIDE LIST */}
                      <Grid
                        item
                        xs={12}
                        md={
                          searchJobIdeasData.searchJobIdeas.length === 0
                            ? 12
                            : 5
                        }
                      >
                        <Box
                          className={classes.detailsAction}
                          style={{
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          <List>
                            {searchJobIdeasData.searchJobIdeas.length === 0 && (
                              <ListItem>
                                <ListItemText>
                                  No results found, please try searching
                                  something else
                                </ListItemText>
                              </ListItem>
                            )}
                            {searchJobIdeasData.searchJobIdeas.map(
                              (o, index) => (
                                <React.Fragment key={o.occupationId}>
                                  <ListItem
                                    button
                                    selected={selectedOccupation === index}
                                    onClick={() => setSelectedOccupation(index)}
                                  >
                                    <ListItemText
                                      primary={
                                        <Highlighter
                                          autoEscape={false}
                                          highlightClassName={classes.highlight}
                                          searchWords={[searchValue]}
                                          textToHighlight={o.title}
                                        />
                                      }
                                      secondary={
                                        <Highlighter
                                          highlightClassName={classes.highlight}
                                          searchWords={[searchValue]}
                                          textToHighlight={o.jobTitleSamples.join(
                                            ", "
                                          )}
                                        />
                                      }
                                    />
                                  </ListItem>

                                  {/* 👇 Mobile-only details below clicked item */}
                                  {isMobile && selectedOccupation === index && (
                                    <Box
                                      className={classes.detailsAction}
                                      style={{
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                      }}
                                    >
                                      <List>
                                        {o.workActivities.map((w) => (
                                          <ListItem key={w.id}>
                                            <ListItemIcon>
                                              <Checkbox
                                                edge="end"
                                                disableRipple
                                                checked={selectedIdeasId.includes(
                                                  w.id
                                                )}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    selectJobIdea(
                                                      w.id,
                                                      w.description
                                                    );
                                                  } else {
                                                    deselectJobIdea(
                                                      w.id,
                                                      w.description
                                                    );
                                                  }
                                                }}
                                              />
                                            </ListItemIcon>
                                            <ListItemText
                                              style={{ textAlign: "justify" }}
                                            >
                                              {w.description}
                                            </ListItemText>
                                          </ListItem>
                                        ))}
                                      </List>
                                    </Box>
                                  )}
                                  <Divider component="li" />
                                </React.Fragment>
                              )
                            )}
                          </List>
                        </Box>
                      </Grid>

                      {/* RIGHT SIDE (desktop only) */}
                      {!isMobile && (
                        <Grid item xs={12} md={7} className="text-center">
                          {searchJobIdeasLoading ||
                          !searchJobIdeasCalled ||
                          searchJobIdeasData.searchJobIdeas.length === 0 ? (
                            ""
                          ) : selectedOccupation === -1 ? (
                            "Select occupation from list"
                          ) : (
                            <Box height="82vh" style={{ overflowX: "auto" }}>
                              <List>
                                {searchJobIdeasData.searchJobIdeas[
                                  selectedOccupation
                                ].workActivities.map((w) => (
                                  <ListItem key={w.id}>
                                    <ListItemIcon>
                                      <Checkbox
                                        edge="end"
                                        disableRipple
                                        checked={selectedIdeasId.includes(w.id)}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            selectJobIdea(w.id, w.description);
                                          } else {
                                            deselectJobIdea(
                                              w.id,
                                              w.description
                                            );
                                          }
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      style={{ textAlign: "justify" }}
                                    >
                                      {w.description}
                                    </ListItemText>
                                  </ListItem>
                                ))}
                              </List>
                            </Box>
                          )}
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Modal>
    </>
  );
};
